export default "__VITE_ASSET__ab58ea92__"